export function isExternalPricingRoute(url: string): boolean {
  if (isExternalPricingPath(url)) {
    return true;
  }
  // Router can still be '/' (or empty) while a /pricing|/payment URL is loading —
  // fall back to the real browser location so auth refresh cannot push users to /login.
  return isExternalPricingLocation();
}

export function isExternalPricingLocation(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return isExternalPricingPath(window.location.pathname + window.location.search);
}

function isExternalPricingPath(url: string): boolean {
  const path = normalizeAppPath(url);
  return (
    path === '/pricing' ||
    path.startsWith('/pricing/') ||
    path === '/payment' ||
    path.startsWith('/payment/')
  );
}

function normalizeAppPath(url: string): string {
  let path = (url ?? '').split('?')[0].split('#')[0];
  if (path.length > 1 && path.endsWith('/')) {
    path = path.slice(0, -1);
  }
  return path.startsWith('/') ? path : `/${path}`;
}

export const EXTERNAL_PRICING_SESSION_NOT_FOUND_PATH = '/pricing/return-not-found';

/**
 * Navigate to the shared not-found page when ExternalSession auth fails because
 * the session is not in Redis 
 */
export function redirectExternalPricingOnSessionNotFound(
  router: { navigateByUrl: (url: string, extras?: { replaceUrl?: boolean }) => unknown },
): void {
  void router.navigateByUrl(EXTERNAL_PRICING_SESSION_NOT_FOUND_PATH, { replaceUrl: true });
}

